import React, { useEffect, useRef, useState } from "react";
import { Menu, Smartphone } from "lucide-react";
import { Link, NavLink, useLocation } from "react-router-dom";
import logo from "../assets/wonso.png";
import { useLanguage } from "../i18n/LanguageProvider";
import LanguageSwitcher from "./LanguageSwitcher";
import ThemeSwitcher from "./ThemeSwitcher";
import MobileNavigation from "./MobileNavigation";

const Header = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(
    () => typeof window !== "undefined" && window.scrollY > 12,
  );
  const menuButtonRef = useRef(null);
  const location = useLocation();
  const { t } = useLanguage();

  useEffect(() => {
    setIsOpen(false);
  }, [location.hash, location.pathname]);

  useEffect(() => {
    let animationFrame = 0;

    const handleScroll = () => {
      window.cancelAnimationFrame(animationFrame);
      animationFrame = window.requestAnimationFrame(() => {
        setIsScrolled(window.scrollY > 12);
      });
    };

    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => {
      window.removeEventListener("scroll", handleScroll);
      window.cancelAnimationFrame(animationFrame);
    };
  }, []);

  useEffect(() => {
    const desktopQuery = window.matchMedia("(min-width: 841px)");
    const closeOnDesktop = ({ matches }) => {
      if (matches) {
        setIsOpen(false);
      }
    };

    desktopQuery.addEventListener("change", closeOnDesktop);
    return () => desktopQuery.removeEventListener("change", closeOnDesktop);
  }, []);

  const navigation = [
    ["Accueil", "/"],
    ["Solutions", "/solutions"],
    ["Business", "/business"],
    ["Tarifs", "/pricing"],
    ["À propos", "/about"],
    ["Contact", "/contact"],
  ];

  return (
    <>
    <header
      className={`ws-header${isScrolled ? " is-scrolled" : ""}${isOpen ? " is-menu-open" : ""}`}
      data-no-i18n="true"
    >
      <div className="ws-header__inner">
        <button
          ref={menuButtonRef}
          className="ws-header__menu-button"
          type="button"
          aria-expanded={isOpen}
          aria-controls="ws-mobile-navigation"
          aria-haspopup="dialog"
          aria-label={t("Ouvrir le menu")}
          onClick={() => setIsOpen(true)}
        >
          <Menu aria-hidden="true" />
        </button>
        <Link
          className="ws-header__brand"
          to="/"
          aria-label={t("WonyaSoft — Accueil")}
        >
          <img
            src={logo}
            alt=""
            className="ws-header__logo"
            width="38"
            height="38"
          />
          <span>WonyaSoft</span>
        </Link>


        <nav
          id="ws-main-navigation"
          className="ws-header__navigation"
          aria-label={t("Menu principal")}
        >
          <ul>
            {navigation.map(([label, route]) => (
              <li key={route}>
                <NavLink to={route} end={route === "/"}>
                  {t(label)}
                </NavLink>
              </li>
            ))}
          </ul>
          <NavLink className="ws-header__app-link" to="/appmobile">
            <Smartphone size={18} aria-hidden="true" />
            <span>{t("Nos applications")}</span>
          </NavLink>
        </nav>

        <div className="ws-header__actions">
          <ThemeSwitcher />
          <LanguageSwitcher />
          <NavLink className="ws-header__app-link" to="/appmobile">
            <Smartphone size={18} aria-hidden="true" />
            <span>{t("Nos applications")}</span>
          </NavLink>
        </div>
      </div>

    </header>
    <MobileNavigation
      isOpen={isOpen}
      onClose={() => setIsOpen(false)}
      menuButtonRef={menuButtonRef}
      navigation={navigation}
    />
    </>
  );
};

export default Header;
